import { _ as _defineProperty } from './defineProperty-377d5a7f.js';
import { _ as _objectWithoutProperties } from './objectWithoutProperties-a0edb288.js';
import { useEffect, useState, useCallback, useRef } from 'react';
import { a as _arrayLikeToArray, b as _unsupportedIterableToArray, _ as _slicedToArray } from './slicedToArray-b4278ecd.js';
import useGeoZone from './useGeozone/index.js';
import createContext from './createContext/index.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { Overlay, VerticalAlign, HorizontalAlign } from '@picsart/overlay';
import { Text, TextElementTypes } from '@picsart/text';
import IconCrossSmall from '@picsart/icons/IconCrossSmall';
import { useTranslator } from '@picsart/rc/services/localization';
import { FontWeights } from '@picsart/cascade/fonts';
import { Texts } from '@picsart/cascade/colors/texts';
import { Typography } from '@picsart/cascade/typography';
import { BreakPoints, ScreenSizes } from '@picsart/cascade/responsive';
import { Button, ButtonSizeXL, ButtonVariants } from '@picsart/button';
import AnalyticsService from '@picsart/rc/services/analytics';
import { createUseStyles } from 'react-jss';
import '@picsart/cascade/styleHelpers/initFavIcons';
import { t as theme } from './styles-2f14f8fb.js';
import '@picsart/rc/useMount';
import '@picsart/cascade/colors/themes';
import { _ as _asyncToGenerator, r as regenerator } from './index-33ee6c9f.js';
import noop from '@picsart/rc/noop';
import getResponseErrorMessage from './getResponseErrorMessage/index.js';
import getReCaptchaToken from './getReCaptchaToken/index.js';
import fetcher from './fetcher/index.js';
import getDeviceId from './getDeviceId/index.js';
import IS_BROWSER from './isBrowser/index.js';
import isDev from './isDev/index.js';
import { FACEBOOK_APP_ID, USER_KEY_DISABLED, USER_KEY_COOKIE_NAME, USER_EMAIL_COOKIE_NAME, API_URL, ResponseStatus, SOCIAL_REQUEST_HEADER_TOKEN } from './configs/constants/index.js';
import { F as FACEBOOK_PLATFORM_SCRIPT_URL, A as ANALYTICS_SCREEN_NAME_KEY, a as ANALYTICS_CONSENTS_KEY, b as AuthActionOptions, S as StatusOptions, c as AnalyticsActionOptions, d as SocialProviderOptions, e as RegErrorReasons, C as ComponentsOptions } from './constants-d756cbb3.js';
import { authStates, authStateKey } from './models/user/index.js';
import { authorizationHeader } from './services/auth/index.js';
import useDelayedScript from './useDelayedScript/index.js';
import { setCookie } from './cookie/index.js';
import { setStorage, removeStorage, getStorage } from './services/browserStorage/index.js';
import errorLogger from './services/errorLogger/index.js';
import { S as SanitizeHtml } from './SanitizeHtml-1e397388.js';
import 'isomorphic-dompurify';
import mediaQuery from '@picsart/cascade/styleHelpers/mediaQuery';

var pageVariant = /*#__PURE__*/function (pageVariant) {
  pageVariant["CONFIRMATION_QUESTION"] = "confirmationQuestion";
  pageVariant["UNDERAGE_MESSAGE"] = "underageMessage";
  pageVariant["TERMS_AND_CONDITIONS"] = "termsAndConditions";
  return pageVariant;
}({});
var Notice = /*#__PURE__*/function (Notice) {
  Notice["AGE_CONFIRMATION"] = "age_confirmation_notice";
  Notice["ACCOUNT_TERMINATION"] = "account_termination_notice";
  return Notice;
}({});
var countryCodes = /*#__PURE__*/function (countryCodes) {
  countryCodes["US"] = "US";
  countryCodes["KR"] = "KR";
  return countryCodes;
}({});

var data$1 = {
  confirmationQuestion: {
    title: 'Are you over 14 years old?',
    description: 'To access and use the Picsart website, you must be 14 years or older.',
    imgSrc: 'https://pastatic.picsart.com/cms-pastatic/15a05b7b-55e0-4f0d-8aa7-1cf6906d8c4a.png',
    note: null,
    buttons: [{
      text: 'Yes',
      filled: true,
      testid: 'age-confirmation-yes',
      isConfirmation: true,
      key: 'age_notice_confirmed'
    }, {
      text: 'No',
      testid: 'age-confirmation-no',
      key: 'age_notice_declined'
    }]
  },
  underageMessage: {
    title: 'Minimum age requirement of 14',
    // eslint-disable-next-line max-len
    description: 'To ensure the safety of everyone in the Picsart creative community, we enforce a minimum age requirement of 14. Based on your current age, you’re not old enough to use Picsart. You will be logged out and your account will be deleted shortly. If your Picsart creations aren’t already saved on your device, you may want to consider downloading them as soon as possible.',
    imgSrc: 'https://pastatic.picsart.com/cms-pastatic/adde162a-60d5-45e5-b063-a5c4bb2dde54.png',
    note: null,
    buttons: [{
      text: 'I understand',
      filled: true,
      testid: 'age-confirmation-iunderstand',
      key: 'account_termination_confirmed',
      isConfirmation: true
    }]
  },
  termsAndConditions: {
    title: "We've updated our policies",
    description: 'To continue using Picsart, you must agree to our updated <a href="/terms-of-use" target="_blank">Terms of Use</a> and <a href="/privacy-policy" target="_blank">Privacy policy</a>',
    note: 'Note: You may skip this step a maximum of',
    imgSrc: 'https://pastatic.picsart.com/cms-pastatic/edfa8170-e36b-4eed-9f08-978f6cbec756.png',
    buttons: [{
      text: 'Accept',
      filled: true,
      testid: 'policy-confirmation-yes',
      isConfirmation: true,
      key: 'policy_notice_confirmed'
    }, {
      text: 'Skip for now',
      testid: 'policy-confirmation-no',
      key: 'policy_notice_skiped'
    }]
  }
};
var popupDeniedPages = ['terms-of-use', 'privacy-policy'];

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var handleFacebookResponse$1 = function handleFacebookResponse(observeUserData) {
  var _window, _window$login;
  (_window = window) === null || _window === void 0 || (_window = _window.FB) === null || _window === void 0 || (_window$login = _window.login) === null || _window$login === void 0 || _window$login.call(_window, function (result) {
    if (result !== null && result !== void 0 && result.authResponse) {
      handleSocialRequestByProvider(result.authResponse.accessToken, 'facebook').then(function (userData) {
        if (userData !== null && userData !== void 0 && userData.token) {
          observeUserData(userData);
        }
        setStorage(authStateKey, authStates.authorized);
        if (!USER_KEY_DISABLED && userData !== null && userData !== void 0 && userData.key) {
          var _userData$key, _userData$email;
          setCookie(USER_KEY_COOKIE_NAME, (_userData$key = userData.key) !== null && _userData$key !== void 0 ? _userData$key : '');
          setCookie(USER_EMAIL_COOKIE_NAME, (_userData$email = userData.email) !== null && _userData$email !== void 0 ? _userData$email : '');
        }
      })["catch"](function (error) {
        console.error('Error handling Facebook response:', error);
      });
    }
  }, {
    scope: 'email,public_profile'
  });
};
function useFacebookAuth(enable) {
  var isScriptLoaded = useDelayedScript(FACEBOOK_PLATFORM_SCRIPT_URL);
  useEffect(function () {
    if (enable) {
      if (!isScriptLoaded) {
        return;
      }
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: FACEBOOK_APP_ID,
          cookie: true,
          // enable cookies to allow the server to access
          xfbml: false,
          // parse social plugins on this page
          version: 'v10.0' // Specify the Graph API version to use
        });
      };
    }
  }, [enable, isScriptLoaded]);
}

// This is a type which is shared between every aspect of this component

var AuthenticationScheme = /*#__PURE__*/function (AuthenticationScheme) {
  AuthenticationScheme[AuthenticationScheme["userKey"] = 0] = "userKey";
  AuthenticationScheme[AuthenticationScheme["bearer"] = 1] = "bearer";
  return AuthenticationScheme;
}({});

/* eslint-disable max-len */
var data = {
  title: 'To get started:',
  privacyPolicy: 'TERMS_OF_USE_KR',
  ariaLabelPrivacyPolice: 'Read our privacy policy',
  mandatory: [{
    id: '1',
    consent: 'terms_of_use_consent',
    label: 'I have read and agree to the Terms of Use.'
  }, {
    id: '2',
    consent: 'above_14_age_consent',
    label: 'I confirm that I am 14 years or older.'
  }, {
    id: '3',
    consent: 'mandatory_pii_consent',
    label: 'I consent to the mandatory collection and use of personal information:',
    description: 'MANDATORY_PII_CONSENT'
  }],
  optionalTitle: 'Optional:',
  optional: [{
    id: '4',
    consent: 'optional_pii_consent',
    label: 'I consent to the optional collection and use of personal information:',
    description: 'OPTIONAL_PII_CONSENT'
  }, {
    id: '5',
    consent: 'pii_usage_and_collect_consent',
    label: 'I consent to the optional collection and use of personal information for receiving updates on Picsart products, services and events:',
    description: 'PII_USAGE_AND_COLLECT_CONSENT'
  }, {
    id: '6',
    consent: 'pii_usage_consent',
    label: 'I consent to receiving updates on Picsart products, services and events:',
    description: 'PII_USAGE_CONSENT'
  }]
};

// Analytics

// Callbacks

// Responses

// Objects

// Requests

// Arguments

var GoogleCallbackSource = /*#__PURE__*/function (GoogleCallbackSource) {
  GoogleCallbackSource["Button"] = "btn";
  GoogleCallbackSource["OneTap"] = "user";
  return GoogleCallbackSource;
}({});

// This function returns all shared analytics for Sign-in / Sign-up and Social registration/login events
var fireCombinedAnalytics = function fireCombinedAnalytics(_ref) {
  var _userData$user, _userData$user2, _userData$user3;
  var action = _ref.action,
    userData = _ref.userData,
    triggeredFrom = _ref.triggeredFrom,
    socialName = _ref.socialName,
    isAuthCombined = _ref.isAuthCombined,
    select_by = _ref.select_by;
  var id = (userData === null || userData === void 0 ? void 0 : userData.id) || ((_userData$user = userData.user) === null || _userData$user === void 0 ? void 0 : _userData$user.id);
  var email = (userData === null || userData === void 0 ? void 0 : userData.email) || ((_userData$user2 = userData.user) === null || _userData$user2 === void 0 ? void 0 : _userData$user2.email);
  var name = (_userData$user3 = userData.user) === null || _userData$user3 === void 0 ? void 0 : _userData$user3.name;
  try {
    if (userData !== null && userData !== void 0 && userData.registered && socialName) {
      // if the user is new username update form must appear
      AnalyticsService.pushDataLayer({
        event: 'complete_registration'
      });
    }
    AnalyticsService.pushDataLayer({
      event: 'gtm_set',
      data: {
        parameters: {
          gtm_userID: id,
          gtm_userEmail: email || '',
          gtm_userName: name || ''
        }
      }
    });
    AnalyticsService.pushDataLayer({
      pulse: 'state',
      user_id: id
    });
    AnalyticsService.sendEvent('registration_done', {
      provider: socialName !== null && socialName !== void 0 ? socialName : 'Picsart',
      registration_type: select_by === GoogleCallbackSource.OneTap ? 'google_one_tap' : 'standard',
      braze: true,
      action_button: triggeredFrom,
      action: action,
      flow_type: isAuthCombined && 'monetization_combined'
    });
    removeStorage(ANALYTICS_SCREEN_NAME_KEY, false);
    removeStorage(ANALYTICS_CONSENTS_KEY, false);
  } catch (error) {
    console.error('Error firing analytics:', error);
    errorLogger.trigger(error, 'error');
  }
};

var MILLISECONDS_PER_SECOND = 1000;
var SECONDS_PER_MINUTE = 60;
var LOCALE = 'en-US';
var formatter = new Intl.DateTimeFormat(LOCALE, {
  timeZone: 'UTC',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  fractionalSecondDigits: 3,
  hour12: false
});
var isDateLessThanOneMinute = function isDateLessThanOneMinute(dateString) {
  var now = new Date();
  var date = new Date(dateString);
  var utcDateStr = formatter.format(date);
  var utcNowStr = formatter.format(now);
  var utcDate = new Date(utcDateStr);
  var utcNow = new Date(utcNowStr);
  var diffInMilliSeconds = utcNow.getTime() - utcDate.getTime();
  var diffInMinutes = Math.round(diffInMilliSeconds / MILLISECONDS_PER_SECOND / SECONDS_PER_MINUTE);
  return diffInMinutes < 1;
};

// This function returns all shared analytics for Signin/Signup and Social registration/login events
var sharedAnalytics = function sharedAnalytics(_ref) {
  var _data$user, _data$response, _data$user2, _data$response2, _data$user3, _data$user4;
  var view = _ref.view,
    data = _ref.data,
    setErrorMessage = _ref.setErrorMessage,
    onSuccess = _ref.onSuccess,
    triggeredFrom = _ref.triggeredFrom,
    _ref$isSocial = _ref.isSocial,
    isSocial = _ref$isSocial === void 0 ? false : _ref$isSocial,
    socialName = _ref.socialName;
  onSuccess && (data === null || data === void 0 ? void 0 : data.user) && onSuccess((data === null || data === void 0 ? void 0 : data.user) || data, data === null || data === void 0 ? void 0 : data.removal_info);
  !isSocial && AnalyticsService.sendEvent('popup_action', {
    name: view && data !== null && data !== void 0 && data.registered ? 'sign_up' : 'sign_in',
    action: 'action_button'
  });
  if (data !== null && data !== void 0 && data.registered && isSocial) {
    // if the user is new username update form must appear
    AnalyticsService.pushDataLayer({
      event: 'complete_registration'
    });
  }
  AnalyticsService.pushDataLayer({
    event: 'gtm_set',
    data: {
      parameters: {
        gtm_userID: (data === null || data === void 0 ? void 0 : data.id) || ((_data$user = data.user) === null || _data$user === void 0 ? void 0 : _data$user.id) || ((_data$response = data.response) === null || _data$response === void 0 ? void 0 : _data$response.id),
        gtm_userEmail: (data === null || data === void 0 ? void 0 : data.email) || ((_data$user2 = data.user) === null || _data$user2 === void 0 ? void 0 : _data$user2.email) || ((_data$response2 = data.response) === null || _data$response2 === void 0 ? void 0 : _data$response2.email) || '',
        gtm_userName: (data === null || data === void 0 || (_data$user3 = data.user) === null || _data$user3 === void 0 ? void 0 : _data$user3.name) || ''
      }
    }
  });
  AnalyticsService.pushDataLayer({
    pulse: 'state',
    user_id: (data === null || data === void 0 ? void 0 : data.id) || ((_data$user4 = data.user) === null || _data$user4 === void 0 ? void 0 : _data$user4.id)
  });
  var accountCreatedAtTimeStamp = data === null || data === void 0 ? void 0 : data.created;
  var isNewlyCreatedUser = accountCreatedAtTimeStamp && isDateLessThanOneMinute(accountCreatedAtTimeStamp);
  AnalyticsService.sendEvent('registration_done', {
    provider: socialName !== null && socialName !== void 0 ? socialName : 'Picsart',
    action: view || isNewlyCreatedUser ? 'sign_up' : 'sign_in',
    registration_type: 'standard',
    braze: true,
    action_button: triggeredFrom
  }, function () {
    !isSocial && setErrorMessage && setErrorMessage('');
  });
};

function debounce(callback) {
  var waitMilliseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var timeout;
  var resolves = [];
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var result;
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return callback.apply(void 0, args);
          case 3:
            result = _context.sent;
            resolves.forEach(function (r) {
              return r(result);
            });
            resolves = [];
            _context.next = 12;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            resolves.forEach(function (r) {
              return r(_context.t0);
            });
            resolves = [];
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    })), waitMilliseconds);
    return new Promise(function (r) {
      return resolves.push(r);
    });
  };
}

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

// HEADERS
var headers = {
  platform: 'website',
  'g-recaptcha-token': '',
  'g-recaptcha-action': '',
  'content-type': 'application/json',
  token: SOCIAL_REQUEST_HEADER_TOKEN
};
var socialHeaders = _objectSpread$1({
  'Content-Type': 'application/json',
  'token-type': 'JWT',
  platform: 'website'
}, getDeviceId() && {
  deviceid: getDeviceId()
});
var mandatory = data.mandatory,
  optional = data.optional;
var consents = [].concat(_toConsumableArray(mandatory), _toConsumableArray(optional));
var getConsents = function getConsents(checkedStates) {
  return checkedStates && consents.filter(function (item) {
    return Object.keys(checkedStates).includes(item.id);
  }).map(function (item) {
    return item.consent;
  });
};

// Request for Sign in/Sign up action
var handleSubmitRequest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(_ref) {
    var body, action, onSuccess, onTerminatedAccount, triggeredFrom, setServerStatus, reCaptchaToken, authenticationScheme, isAuthCombined, viewUrl, bodyData;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          body = _ref.body, action = _ref.action, onSuccess = _ref.onSuccess, onTerminatedAccount = _ref.onTerminatedAccount, triggeredFrom = _ref.triggeredFrom, setServerStatus = _ref.setServerStatus, reCaptchaToken = _ref.reCaptchaToken, authenticationScheme = _ref.authenticationScheme, isAuthCombined = _ref.isAuthCombined;
          headers['g-recaptcha-action'] = action;
          headers['g-recaptcha-token'] = reCaptchaToken;
          viewUrl = "user-account/".concat(action.toLowerCase(), ".json");
          bodyData = body;
          if (authenticationScheme === AuthenticationScheme.bearer) {
            delete bodyData.isLocal;
            if (action === AuthActionOptions.SignIn) {
              delete bodyData.email;
              viewUrl = "user-account/auth/".concat(action.toLowerCase());
            } else {
              viewUrl = "user-account/auth/".concat(action.toLowerCase());
            }
          }
          AnalyticsService.sendEvent('popup_action', {
            name: action === AuthActionOptions.SignIn ? 'sign_in' : 'sign_up',
            action: 'action_button'
          });
          _context2.next = 9;
          return fetcher("".concat(API_URL, "/").concat(viewUrl), {
            method: 'POST',
            body: JSON.stringify(bodyData),
            headers: headers,
            credentials: 'include'
          }).then( /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(data) {
              return regenerator.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!((data === null || data === void 0 ? void 0 : data.status) === ResponseStatus.success)) {
                      _context.next = 6;
                      break;
                    }
                    _context.next = 3;
                    return fireCombinedAnalytics({
                      action: action === AuthActionOptions.SignIn ? AnalyticsActionOptions.SignIn : AnalyticsActionOptions.SignUp,
                      userData: data,
                      triggeredFrom: triggeredFrom,
                      isAuthCombined: isAuthCombined
                    });
                  case 3:
                    onSuccess((data === null || data === void 0 ? void 0 : data.user) || data, data === null || data === void 0 ? void 0 : data.removal_info);
                    _context.next = 13;
                    break;
                  case 6:
                    if (!(data !== null && data !== void 0 && data.removal_info)) {
                      _context.next = 12;
                      break;
                    }
                    if (!onTerminatedAccount) {
                      _context.next = 10;
                      break;
                    }
                    _context.next = 10;
                    return onTerminatedAccount(data.removal_info);
                  case 10:
                    _context.next = 13;
                    break;
                  case 12:
                    setServerStatus({
                      type: StatusOptions.Error,
                      message: data === null || data === void 0 ? void 0 : data.message,
                      reason: data === null || data === void 0 ? void 0 : data.reason
                    });
                  case 13:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x2) {
              return _ref3.apply(this, arguments);
            };
          }())["catch"](function (err) {
            setServerStatus === null || setServerStatus === void 0 || setServerStatus({
              type: StatusOptions.Error,
              message: getResponseErrorMessage(err),
              reason: (err === null || err === void 0 ? void 0 : err.reason) || ''
            });
          });
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function handleSubmitRequest(_x) {
    return _ref2.apply(this, arguments);
  };
}();

// Main submit function for  Sign in/Sign up form(including request)
var handleSubmit = function handleSubmit(_ref4) {
  var email = _ref4.email,
    username = _ref4.username,
    password = _ref4.password,
    preventReCaptcha = _ref4.preventReCaptcha,
    action = _ref4.action,
    checkUser = _ref4.checkUser,
    onTerminatedAccount = _ref4.onTerminatedAccount,
    emailConsent = _ref4.emailConsent,
    triggeredFrom = _ref4.triggeredFrom,
    setServerStatus = _ref4.setServerStatus,
    authenticationScheme = _ref4.authenticationScheme,
    checkedStates = _ref4.checkedStates,
    isAuthCombined = _ref4.isAuthCombined;
  var consents = getConsents(checkedStates);
  var reqData = {
    password: password
  };
  if (action === AuthActionOptions.SignUp) {
    reqData = _objectSpread$1(_objectSpread$1(_objectSpread$1({}, reqData), {
      email: email
    }), {
      consents: consents
    });
  } else {
    reqData = _objectSpread$1(_objectSpread$1({}, reqData), {
      username: username || email
    });
  }
  if (authenticationScheme === AuthenticationScheme.userKey) {
    reqData = _objectSpread$1(_objectSpread$1(_objectSpread$1({}, reqData), action === AuthActionOptions.SignUp && {
      email_subscription_consent: emailConsent
    }), {
      email: email,
      isLocal: isDev
    });
  }
  if (action === AuthActionOptions.SignIn) {
    if (!preventReCaptcha) {
      getReCaptchaToken(action).then(function (_ref5) {
        var status = _ref5.status,
          token = _ref5.token;
        if (status === 'success') {
          handleSubmitRequest({
            body: reqData,
            action: AuthActionOptions.SignIn,
            onSuccess: checkUser,
            authenticationScheme: authenticationScheme,
            setServerStatus: setServerStatus,
            onTerminatedAccount: onTerminatedAccount,
            triggeredFrom: triggeredFrom,
            reCaptchaToken: token,
            isAuthCombined: isAuthCombined
          });
        }
      })["catch"](function (err) {
        setServerStatus === null || setServerStatus === void 0 || setServerStatus({
          type: StatusOptions.Error,
          message: getResponseErrorMessage(err)
        });
      });
    } else {
      handleSubmitRequest({
        body: reqData,
        action: AuthActionOptions.SignIn,
        onSuccess: checkUser,
        onTerminatedAccount: onTerminatedAccount,
        triggeredFrom: triggeredFrom,
        authenticationScheme: authenticationScheme,
        setServerStatus: setServerStatus,
        isAuthCombined: isAuthCombined
      });
    }
  } else if (!preventReCaptcha) {
    getReCaptchaToken(action).then(function (_ref6) {
      var status = _ref6.status,
        token = _ref6.token;
      if (status === 'success') {
        handleSubmitRequest({
          body: reqData,
          action: AuthActionOptions.SignUp,
          onSuccess: checkUser,
          setServerStatus: setServerStatus,
          authenticationScheme: authenticationScheme,
          onTerminatedAccount: onTerminatedAccount,
          triggeredFrom: triggeredFrom,
          reCaptchaToken: token,
          isAuthCombined: isAuthCombined
        });
      }
    })["catch"](function (err) {
      setServerStatus === null || setServerStatus === void 0 || setServerStatus({
        type: StatusOptions.Error,
        message: getResponseErrorMessage(err)
      });
    });
  } else {
    handleSubmitRequest({
      body: reqData,
      action: AuthActionOptions.SignUp,
      onSuccess: checkUser,
      onTerminatedAccount: onTerminatedAccount,
      triggeredFrom: triggeredFrom,
      authenticationScheme: authenticationScheme,
      setServerStatus: setServerStatus,
      isAuthCombined: isAuthCombined
    });
  }
};

// Submit function for  Google and Facebook socials excluding Apple
var handleSocialSignIn = function handleSocialSignIn(_ref7) {
  var socialName = _ref7.socialName,
    basePath = _ref7.basePath,
    checkUser = _ref7.checkUser,
    triggeredFrom = _ref7.triggeredFrom,
    _ref7$authenticationS = _ref7.authenticationScheme,
    authenticationScheme = _ref7$authenticationS === void 0 ? AuthenticationScheme.bearer : _ref7$authenticationS,
    _ref7$userData = _ref7.userData,
    userData = _ref7$userData === void 0 ? null : _ref7$userData,
    isAuthCombined = _ref7.isAuthCombined;
  return function (e) {
    e === null || e === void 0 || e.preventDefault();
    var url = "".concat(basePath, "auth/").concat(socialName, "?popupMode=1");
    if (!IS_BROWSER) {
      return;
    }
    if (authenticationScheme === AuthenticationScheme.bearer) {
      handleBearerSocialSignIn(socialName, userData, true, checkUser, triggeredFrom)(e);
      return;
    }
    var signInWindow = window.open(url, 'signInWindow', 'width=600,height=600');
    var signInWindowClosedInterval = setInterval(function () {
      if (signInWindow.closed) {
        clearInterval(signInWindowClosedInterval);
        fetcher('/user', {
          method: 'GET',
          headers: socialHeaders,
          credentials: 'include'
          // TODO: add correct types for UserResponse
        }).then(function (data) {
          var user = data.user,
            removal_info = data.removal_info,
            status = data.status;
          if (status === ResponseStatus.success) {
            // Firing Analytics events for the Social except Apple
            var accountCreatedAtTimeStamp = data === null || data === void 0 ? void 0 : data.created;
            var isNewlyCreatedUser = accountCreatedAtTimeStamp && isDateLessThanOneMinute(accountCreatedAtTimeStamp);
            fireCombinedAnalytics({
              action: isNewlyCreatedUser ? AnalyticsActionOptions.SignUp : AnalyticsActionOptions.SignIn,
              userData: data,
              triggeredFrom: triggeredFrom,
              socialName: socialName,
              isAuthCombined: isAuthCombined
            });
            if (data.user) {
              checkUser(data === null || data === void 0 ? void 0 : data.user, data === null || data === void 0 ? void 0 : data.removal_info);
            } else {
              checkUser(data, data === null || data === void 0 ? void 0 : data.removal_info);
            }
          } else {
            checkUser && checkUser(user, removal_info);
          }
        })["catch"](function (error) {
          console.error('Error in social sign in:', error);
        });
      }
    }, 500);
  };
};

// Check dublication of below
var handleSocialData = function handleSocialData(socialName, data, isSignUpView, checkUser, triggeredFrom) {
  if (data && data.status === 'success') {
    sharedAnalytics({
      view: isSignUpView,
      data: {
        user: data
      },
      setErrorMessage: noop,
      onSuccess: checkUser,
      triggeredFrom: triggeredFrom,
      isSocial: true,
      socialName: socialName
    });
  } else {
    throw new Error('userData is Empty');
  }
};

// Submit function for  Google and Facebook socials(not including Apple)
var handleBearerSocialSignIn = function handleBearerSocialSignIn(socialName, userData, isSignUpView, checkUser, triggeredFrom) {
  return function (e) {
    e === null || e === void 0 || e.preventDefault();
    if (IS_BROWSER) {
      var _data = userData;
      setStorage(authStateKey, authStates.authorized);
      if (!USER_KEY_DISABLED && userData !== null && userData !== void 0 && userData.key) {
        var _userData$key, _userData$email;
        setCookie(USER_KEY_COOKIE_NAME, (_userData$key = userData.key) !== null && _userData$key !== void 0 ? _userData$key : '');
        setCookie(USER_EMAIL_COOKIE_NAME, (_userData$email = userData.email) !== null && _userData$email !== void 0 ? _userData$email : '');
      }
      if (socialName === 'facebook') {
        var observeUserData = function observeUserData(userSocialData) {
          _data = userSocialData;
          handleSocialData(socialName, _data, isSignUpView, checkUser, triggeredFrom);
        };
        handleFacebookResponse$1(observeUserData);
        return;
      }
      handleSocialData(socialName, _data, isSignUpView, checkUser, triggeredFrom);
    }
  };
};
// Check dubclication of above

var handleConsentConfirmation = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(_ref8) {
    var isConsentReached, accessToken, countryCode, consent;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          isConsentReached = _ref8.isConsentReached, accessToken = _ref8.accessToken, countryCode = _ref8.countryCode;
          _context3.t0 = countryCode;
          _context3.next = _context3.t0 === 'kr' ? 4 : _context3.t0 === 'us' ? 6 : 8;
          break;
        case 4:
          consent = 'above_14_age_consent';
          return _context3.abrupt("break", 9);
        case 6:
          consent = 'terms_and_condition_consent';
          return _context3.abrupt("break", 9);
        case 8:
          consent = 'above_14_age_consent';
        case 9:
          _context3.next = 11;
          return fetcher("".concat(API_URL, "/users/consent"), {
            method: 'POST',
            body: JSON.stringify(_defineProperty({}, consent, isConsentReached)),
            headers: _objectSpread$1(_objectSpread$1({}, authorizationHeader(accessToken)), {}, {
              'content-type': 'application/json',
              'country-code': countryCode
            })
          });
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function handleConsentConfirmation(_x3) {
    return _ref9.apply(this, arguments);
  };
}();
var handleNewSocialRequest = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(_ref10) {
    var credential, provider, checkUser, checkedStates, setCurrentPage, triggeredFrom, onClick, isAuthCombined, select_by, consents;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          credential = _ref10.credential, provider = _ref10.provider, checkUser = _ref10.checkUser, checkedStates = _ref10.checkedStates, setCurrentPage = _ref10.setCurrentPage, triggeredFrom = _ref10.triggeredFrom, onClick = _ref10.onClick, isAuthCombined = _ref10.isAuthCombined, select_by = _ref10.select_by;
          consents = getConsents(checkedStates);
          _context4.next = 4;
          return fetcher("".concat(API_URL, "/user-account/auth/social"), {
            method: 'POST',
            headers: socialHeaders,
            credentials: 'include',
            body: JSON.stringify({
              provider: SocialProviderOptions[provider],
              data: {
                token: credential
              },
              consents: consents
            })
          }).then(function (data) {
            var user = data.user,
              removal_info = data.removal_info,
              status = data.status;
            if (status === ResponseStatus.success) {
              // Firing Analytics events for the Social,
              fireCombinedAnalytics({
                action: data !== null && data !== void 0 && data.registered ? AnalyticsActionOptions.SignUp : AnalyticsActionOptions.SignIn,
                userData: data,
                triggeredFrom: triggeredFrom,
                socialName: SocialProviderOptions[provider],
                isAuthCombined: isAuthCombined,
                select_by: select_by
              });
              checkUser((data === null || data === void 0 ? void 0 : data.user) || data, data === null || data === void 0 ? void 0 : data.removal_info);
              onClick === null || onClick === void 0 || onClick(SocialProviderOptions[provider], user)(null);
            } else {
              checkUser(user, removal_info);
            }
          })["catch"](function (err) {
            if (err.reason === RegErrorReasons.Consents && setCurrentPage) {
              setCurrentPage(ComponentsOptions.ToGetStarted);
            }
            console.error('handleNewSocialRequest -', err);
          });
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function handleNewSocialRequest(_x4) {
    return _ref11.apply(this, arguments);
  };
}();
function handleSocialRequestByProvider(_x5, _x6) {
  return _handleSocialRequestByProvider.apply(this, arguments);
}

// Submit function for  Apple social
function _handleSocialRequestByProvider() {
  _handleSocialRequestByProvider = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee11(credential, provider) {
    var response, result;
    return regenerator.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          _context11.next = 3;
          return fetcher("".concat(API_URL, "/user-account/auth/social"), {
            body: JSON.stringify({
              provider: provider,
              data: {
                token: credential
              }
            }),
            credentials: 'include',
            headers: socialHeaders,
            method: 'POST'
          });
        case 3:
          response = _context11.sent;
          if (response.ok) {
            _context11.next = 6;
            break;
          }
          throw new Error("Failed to fetch: ".concat(response.statusText));
        case 6:
          _context11.next = 8;
          return response.json();
        case 8:
          result = _context11.sent;
          return _context11.abrupt("return", result);
        case 12:
          _context11.prev = 12;
          _context11.t0 = _context11["catch"](0);
          console.error('Error in handleSocialRequestByProvider:', _context11.t0);
          throw _context11.t0;
        case 16:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[0, 12]]);
  }));
  return _handleSocialRequestByProvider.apply(this, arguments);
}
var handleAppleRequest = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(_ref12) {
    var appleData, checkUser, triggeredFrom, setCurrentPage, checkedStates, setSocialData, isAuthCombined, data, id_token;
    return regenerator.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          appleData = _ref12.appleData, checkUser = _ref12.checkUser, triggeredFrom = _ref12.triggeredFrom, setCurrentPage = _ref12.setCurrentPage, checkedStates = _ref12.checkedStates, setSocialData = _ref12.setSocialData, isAuthCombined = _ref12.isAuthCombined;
          data = appleData && appleData.authorization;
          id_token = data.id_token;
          setSocialData && setSocialData({
            provider: SocialProviderOptions.apple,
            credential: id_token
          });
          _context5.t0 = data && !appleData.error;
          if (!_context5.t0) {
            _context5.next = 8;
            break;
          }
          _context5.next = 8;
          return handleNewSocialRequest({
            credential: id_token,
            provider: SocialProviderOptions.apple,
            checkUser: checkUser,
            checkedStates: checkedStates,
            setCurrentPage: setCurrentPage,
            triggeredFrom: triggeredFrom,
            isAuthCombined: isAuthCombined
          });
        case 8:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function handleAppleRequest(_x7) {
    return _ref13.apply(this, arguments);
  };
}();

// Google sign-in success callback (for button and oneTap)
var handleGoogleResponse = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(_ref14) {
    var accountData, checkUser, triggeredFrom, onClick, checkedStates, setCurrentPage, setSocialData, isAuthCombined, credential, select_by;
    return regenerator.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          accountData = _ref14.accountData, checkUser = _ref14.checkUser, triggeredFrom = _ref14.triggeredFrom, onClick = _ref14.onClick, checkedStates = _ref14.checkedStates, setCurrentPage = _ref14.setCurrentPage, setSocialData = _ref14.setSocialData, isAuthCombined = _ref14.isAuthCombined;
          if (accountData !== null && accountData !== void 0 && accountData.credential) {
            _context6.next = 3;
            break;
          }
          throw Error('Empty account data!');
        case 3:
          setSocialData && setSocialData({
            provider: SocialProviderOptions.google,
            credential: accountData.credential
          });
          credential = accountData.credential, select_by = accountData.select_by;
          _context6.next = 7;
          return handleNewSocialRequest({
            credential: credential,
            provider: SocialProviderOptions.google,
            checkUser: checkUser,
            checkedStates: checkedStates,
            setCurrentPage: setCurrentPage,
            triggeredFrom: triggeredFrom,
            onClick: onClick,
            isAuthCombined: isAuthCombined,
            select_by: select_by
          });
        case 7:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function handleGoogleResponse(_x8) {
    return _ref15.apply(this, arguments);
  };
}();
var handleFacebookResponse = function handleFacebookResponse(_ref16) {
  var _window, _window$login;
  var checkUser = _ref16.checkUser,
    triggeredFrom = _ref16.triggeredFrom,
    checkedStates = _ref16.checkedStates,
    setCurrentPage = _ref16.setCurrentPage,
    setSocialData = _ref16.setSocialData,
    isAuthCombined = _ref16.isAuthCombined;
  (_window = window) === null || _window === void 0 || (_window = _window.FB) === null || _window === void 0 || (_window$login = _window.login) === null || _window$login === void 0 || _window$login.call(_window, /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7(result) {
      return regenerator.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            if (!(result !== null && result !== void 0 && result.authResponse)) {
              _context7.next = 5;
              break;
            }
            setSocialData && setSocialData({
              provider: SocialProviderOptions.facebook,
              credential: result.authResponse.accessToken
            });
            _context7.next = 5;
            return handleNewSocialRequest({
              credential: result.authResponse.accessToken,
              provider: SocialProviderOptions.facebook,
              checkUser: checkUser,
              checkedStates: checkedStates,
              setCurrentPage: setCurrentPage,
              triggeredFrom: triggeredFrom,
              isAuthCombined: isAuthCombined
            });
          case 5:
            _context7.next = 10;
            break;
          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7["catch"](0);
            console.error('Error in handleFacebookResponse:', _context7.t0);
          case 10:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[0, 7]]);
    }));
    return function (_x9) {
      return _ref17.apply(this, arguments);
    };
  }(), {
    scope: 'email,public_profile'
  });
};
var userLogout = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(accessToken) {
    return regenerator.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt("return", fetch("".concat(API_URL, "/users/signout.json"), {
            method: 'POST',
            headers: _objectSpread$1({
              platform: 'website'
            }, authorizationHeader(accessToken)),
            credentials: 'include',
            body: JSON.stringify({})
          }));
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function userLogout(_x10) {
    return _ref18.apply(this, arguments);
  };
}();
var refreshTokenRequest = debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9() {
  var headers,
    getRefreshTokenHeader,
    _args9 = arguments;
  return regenerator.wrap(function _callee9$(_context9) {
    while (1) switch (_context9.prev = _context9.next) {
      case 0:
        headers = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
        getRefreshTokenHeader = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : null;
        return _context9.abrupt("return", fetch("".concat(API_URL, "/oauth2/refresh"), {
          headers: _objectSpread$1({
            'content-type': 'application/json',
            platform: 'website'
          }, headers),
          credentials: 'include',
          body: JSON.stringify({}),
          method: 'POST'
        }).then(function (res) {
          var _res$headers;
          if (res.status >= 400) {
            throw new Error(res.status.toString());
          }
          getRefreshTokenHeader === null || getRefreshTokenHeader === void 0 || getRefreshTokenHeader(res === null || res === void 0 || (_res$headers = res.headers) === null || _res$headers === void 0 ? void 0 : _res$headers.get('set-cookie'));
          return res.json();
        })["catch"](function (err) {
          throw err;
        }));
      case 3:
      case "end":
        return _context9.stop();
    }
  }, _callee9);
})), 300);
var refreshToken = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee10() {
    var headers,
      getRefreshTokenHeader,
      _args10 = arguments;
    return regenerator.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          headers = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          getRefreshTokenHeader = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : null;
          return _context10.abrupt("return", refreshTokenRequest(headers, getRefreshTokenHeader));
        case 3:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function refreshToken() {
    return _ref20.apply(this, arguments);
  };
}();
function getUser(_x11) {
  return _getUser.apply(this, arguments);
}
function _getUser() {
  _getUser = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee12(accessToken) {
    var userData;
    return regenerator.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return fetch("".concat(API_URL, "/users/show/me.json?email_encoded=1"), {
            headers: authorizationHeader(accessToken)
          });
        case 3:
          userData = _context12.sent;
          return _context12.abrupt("return", userData.json());
        case 7:
          _context12.prev = 7;
          _context12.t0 = _context12["catch"](0);
          console.error(_context12.t0);
          return _context12.abrupt("return", null);
        case 11:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 7]]);
  }));
  return _getUser.apply(this, arguments);
}

var getAnalyticsScreenNameForKorea = function getAnalyticsScreenNameForKorea(page) {
  if (page.toLowerCase() === pageVariant.CONFIRMATION_QUESTION.toLowerCase()) {
    return Notice.AGE_CONFIRMATION;
  }
  return Notice.ACCOUNT_TERMINATION;
};

var localStorageCounter = function localStorageCounter(id, change) {
  var times = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var key = "terms-".concat(id);
  if (change === 'remove') {
    removeStorage(key);
    return;
  }
  if (!getStorage(key)) {
    setStorage(key, times.toString());
  }
  if (getStorage(key) && change === 'decrease') {
    var value = Number(getStorage(key)) - 1;
    setStorage(key, value.toString());
  }
};

var useStyles = createUseStyles(function (_ref) {
  var spacings = _ref.spacings,
    colors = _ref.colors,
    radiuses = _ref.radiuses;
  return {
    wrapper: _defineProperty(_defineProperty({
      display: 'grid',
      alignContent: 'baseline',
      boxSizing: 'border-box',
      // TODO Need to set correct type
      width: function width(props) {
        return props.pageVariantStyle ? 326 : 360;
      },
      maxHeight: 440,
      padding: [spacings.s56, spacings.s24],
      position: 'relative',
      backgroundColor: colors.backgrounds.positive,
      borderRadius: radiuses.r16,
      boxShadow: "0px 8px 20px ".concat(colors.texts.tint3)
    }, mediaQuery(BreakPoints.Small), {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: 326,
      right: spacings.s0,
      bottom: spacings.s0,
      boxShadow: "0 8 0 ".concat(colors.backgrounds.positive),
      width: function width() {
        return '100%';
      },
      height: function height() {
        return '100%';
      }
    }), '& p', {
      textAlign: 'center'
    }),
    image: {
      margin: [spacings.s0, 'auto', spacings.s24],
      width: 48,
      height: 48
    },
    description: {
      marginTop: spacings.s8,
      '&  a': {
        color: colors.accents.primary.base["default"],
        fontWeight: 'bold'
      }
    },
    note: {
      marginTop: spacings.s8
    },
    closeIcon: {
      width: 20,
      height: 20,
      borderRadius: '50%',
      backgroundColor: colors.backgrounds.negative,
      position: 'absolute',
      top: spacings.s10,
      right: spacings.s10,
      cursor: 'pointer',
      display: function display(props) {
        return props.hideSkipBtn ? 'none' : 'initial';
      }
    },
    buttonsHolder: _defineProperty({
      display: 'grid',
      marginTop: spacings.s24,
      gap: spacings.s8,
      '& > :last-child': {
        display: function display(props) {
          return props.hideSkipBtn ? 'none' : 'initial';
        }
      }
    }, mediaQuery(BreakPoints.Small), {
      position: 'absolute',
      bottom: spacings.s32,
      right: spacings.s24,
      left: spacings.s24
    })
  };
}, {
  name: 'age-confirmation-popup'
});

var AgeConfirmationPopup = function AgeConfirmationPopup(_ref) {
  var country = _ref.country;
  var _useState = useState(country === countryCodes.KR ? pageVariant.CONFIRMATION_QUESTION : pageVariant.TERMS_AND_CONDITIONS),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isModalOpen = _useState4[0],
    setIsModalOpen = _useState4[1];
  var _useAuthContext = useAuthContext(),
    tokenDataRef = _useAuthContext.tokenDataRef,
    user = _useAuthContext.user;
  var pageVariantStyle = page === pageVariant.CONFIRMATION_QUESTION;
  var remainingTimes = getStorage("terms-".concat(user === null || user === void 0 ? void 0 : user.id));
  var isUS = country === countryCodes.US;
  var canSkip = Number(remainingTimes) > 0;
  var hideSkipBtn = !canSkip && isUS;
  // TODO Need to set correct type
  var styles = useStyles({
    pageVariantStyle: pageVariantStyle,
    hideSkipBtn: hideSkipBtn
  });
  var translate = useTranslator();
  var handleSkipClick = useCallback(function () {
    setIsModalOpen(false);
    localStorageCounter(user === null || user === void 0 ? void 0 : user.id, 'decrease');
  }, [user === null || user === void 0 ? void 0 : user.id]);
  var handleClick = useCallback(function (e, isConfirmation, analyticsItem) {
    AnalyticsService.sendEvent('button_click', {
      screen_name: getAnalyticsScreenNameForKorea(page),
      item: analyticsItem
    });
    if (isConfirmation) {
      setIsModalOpen(false);
      if (page === pageVariant.TERMS_AND_CONDITIONS) {
        localStorageCounter(user === null || user === void 0 ? void 0 : user.id, 'remove');
      }
    } else {
      if (page === pageVariant.CONFIRMATION_QUESTION) {
        setPage(pageVariant.UNDERAGE_MESSAGE);
      }
      if (page === pageVariant.TERMS_AND_CONDITIONS) {
        handleSkipClick();
      }
    }
    if (page === pageVariant.CONFIRMATION_QUESTION || page === pageVariant.TERMS_AND_CONDITIONS && isConfirmation) {
      var _tokenDataRef$current;
      handleConsentConfirmation({
        isConsentReached: !!isConfirmation,
        accessToken: tokenDataRef === null || tokenDataRef === void 0 || (_tokenDataRef$current = tokenDataRef.current) === null || _tokenDataRef$current === void 0 ? void 0 : _tokenDataRef$current.access_token,
        countryCode: (country === null || country === void 0 ? void 0 : country.toLowerCase()) || ''
      }).then(function () {
        AnalyticsService.sendEvent('consent_response', {
          consent_type: 'registration_consent',
          action: isConfirmation ? 'confirm' : 'declined',
          checkbox: ''
        });
      })["catch"](function (e) {
        return errorLogger.trigger(e, 'error');
      });
    }
  }, [page, tokenDataRef, country, user === null || user === void 0 ? void 0 : user.id, handleSkipClick]);
  useEffect(function () {
    // Analytics
    if (isModalOpen) {
      if (page === pageVariant.CONFIRMATION_QUESTION) {
        AnalyticsService.sendEvent('popup_open', {
          name: 'age_confirmation_notice'
        });
      } else {
        AnalyticsService.sendEvent('popup_open', {
          name: 'account_termination_notice'
        });
      }
    }
  }, [page, isModalOpen]);
  useEffect(function () {
    isUS && localStorageCounter(user === null || user === void 0 ? void 0 : user.id);
  }, [isUS, user === null || user === void 0 ? void 0 : user.id]);
  return /*#__PURE__*/jsx(Fragment, {
    children: !isModalOpen ? null : /*#__PURE__*/jsx(Overlay, {
      closeCallback: function closeCallback() {
        return false;
      },
      hideScrollbars: true,
      verticalAlign: VerticalAlign === null || VerticalAlign === void 0 ? void 0 : VerticalAlign.Middle,
      horizontalAlign: HorizontalAlign === null || HorizontalAlign === void 0 ? void 0 : HorizontalAlign.Center,
      zIndex: 1000000,
      children: /*#__PURE__*/jsxs("div", {
        className: styles.wrapper,
        "data-testid": "age-confirmation-wrapper",
        children: [isUS && /*#__PURE__*/jsx(IconCrossSmall, {
          fill: theme.colors.backgrounds.positive,
          name: "close-small-gen",
          className: styles.closeIcon,
          onClick: handleSkipClick
        }), /*#__PURE__*/jsx("img", {
          className: styles.image,
          src: data$1[page].imgSrc,
          alt: ""
        }), /*#__PURE__*/jsx(Text, {
          elementType: TextElementTypes.Paragraph,
          size: _defineProperty({
            Default: Typography.t6
          }, ScreenSizes.XL, Typography.t6),
          color: Texts.negative,
          weight: FontWeights.Bold,
          children: translate(data$1[page].title)
        }), /*#__PURE__*/jsx(Text, {
          className: styles.description,
          elementType: TextElementTypes.Paragraph,
          size: _defineProperty({
            Default: Typography.t4
          }, ScreenSizes.XL, Typography.t4),
          color: Texts.tint2,
          weight: FontWeights.Medium,
          children: /*#__PURE__*/jsx(SanitizeHtml, {
            tag: "div",
            html: data$1[page].description
          })
        }), canSkip && data$1[page].note && /*#__PURE__*/jsx(Text, {
          className: styles.note,
          elementType: TextElementTypes.Paragraph,
          size: _defineProperty({
            Default: Typography.t4
          }, ScreenSizes.XL, Typography.t4),
          color: Texts.tint2,
          children: translate("".concat(data$1[page].note, " ").concat(remainingTimes, " times"))
        }), /*#__PURE__*/jsx("div", {
          className: styles.buttonsHolder,
          children: data$1[page].buttons.map(function (button) {
            return /*#__PURE__*/jsx(Button, {
              "data-testid": button.testid,
              onClick: function onClick(e) {
                return handleClick(e, button.isConfirmation, button.key);
              },
              size: ButtonSizeXL,
              variant: !button.filled ? ButtonVariants.Outline : ButtonVariants.Filled,
              isFullWidth: true,
              children: translate(button.text)
            }, button.key);
          })
        })]
      })
    })
  });
};

var AgeConfirmationPopupWrapper = function AgeConfirmationPopupWrapper(_ref) {
  var isWhiteLabel = _ref.isWhiteLabel;
  var _useAuthContext = useAuthContext(),
    user = _useAuthContext.user;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    country = _useState2[0],
    setCountry = _useState2[1];
  useGeoZone(function (geoZone) {
    setCountry(geoZone);
  });
  var showPopup = (country === countryCodes.US && !popupDeniedPages.some(function (v) {
    return window.location.href.includes(v);
  }) || country === countryCodes.KR) && !isWhiteLabel;
  return /*#__PURE__*/jsx(Fragment, {
    children: (user === null || user === void 0 ? void 0 : user.is_consent_reacted) === false && showPopup && /*#__PURE__*/jsx(AgeConfirmationPopup, {
      country: country
    })
  });
};

/**
 * Authorization states. If user authorized: pending => done (token fetched) => resolved (user fetched). If user unauthorized: pending => failed (logout state).
 * @readonly
 * @enum {string}
 */
var authStatus = /*#__PURE__*/function (authStatus) {
  authStatus["pending"] = "pending";
  authStatus["resolved"] = "resolved";
  authStatus["failed"] = "failed";
  authStatus["done"] = "done";
  return authStatus;
}({});
var StorageType = /*#__PURE__*/function (StorageType) {
  StorageType["COUNT"] = "count";
  StorageType["SIZE"] = "size";
  return StorageType;
}({});

// import isDev from 'utils/isDev';
var defaultState = {
  user: null,
  status: authStatus.pending,
  basePath: '/',
  user_storage_data: null,
  tokenData: null
};

var _excluded = ["children", "tokenData", "isWhiteLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _createContext = createContext(defaultState, 'AuthContext'),
  AuthenticationContext = _createContext.context,
  useAuthContext = _createContext.useContext;
function AuthProvider(_ref) {
  var children = _ref.children,
    tokenData = _ref.tokenData,
    isWhiteLabel = _ref.isWhiteLabel,
    props = _objectWithoutProperties(_ref, _excluded);
  var tokenDataRef = useRef(tokenData || null);
  return /*#__PURE__*/jsxs(AuthenticationContext.Provider, {
    value: _objectSpread(_objectSpread({}, defaultState), {}, {
      tokenData: tokenData,
      tokenDataRef: tokenDataRef
    }, props),
    children: [children, /*#__PURE__*/jsx(AgeConfirmationPopupWrapper, {
      isWhiteLabel: isWhiteLabel
    })]
  });
}

export { AuthProvider as A, StorageType as S, authStatus as a, handleAppleRequest as b, handleFacebookResponse as c, handleSocialSignIn as d, handleSubmit as e, handleGoogleResponse as f, AuthenticationScheme as g, handleNewSocialRequest as h, userLogout as i, getUser as j, AgeConfirmationPopup as k, AgeConfirmationPopupWrapper as l, AuthenticationContext as m, useFacebookAuth as n, data as o, refreshToken as r, useAuthContext as u };
//# sourceMappingURL=authContext-fe8fc8dc.js.map
